import { render, staticRenderFns } from "./events-list.vue?vue&type=template&id=3f9861d7&scoped=true&"
import script from "./events-list.vue?vue&type=script&lang=js&"
export * from "./events-list.vue?vue&type=script&lang=js&"
import style0 from "./events-list.vue?vue&type=style&index=0&id=3f9861d7&prod&lang=scss&"
import style1 from "./events-list.vue?vue&type=style&index=1&id=3f9861d7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9861d7",
  null
  
)

export default component.exports